import { render, staticRenderFns } from "./TemplateMaker.vue?vue&type=template&id=4f1617d8&"
import script from "./TemplateMaker.vue?vue&type=script&lang=js&"
export * from "./TemplateMaker.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMaker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1617d8')) {
      api.createRecord('4f1617d8', component.options)
    } else {
      api.reload('4f1617d8', component.options)
    }
    module.hot.accept("./TemplateMaker.vue?vue&type=template&id=4f1617d8&", function () {
      api.rerender('4f1617d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/formioTemplates/vistas/TemplateMaker.vue"
export default component.exports